<script setup lang="ts">
import './assets/style.scss'
import { useNotification, VIcons } from '@/shared/ui'
import { useTranslate } from '@/shared/lib'

const zoom = defineModel('zoom')
const center = defineModel('center')

const { addError } = useNotification()
const { trs } = useTranslate()

/**
 * Функция определения местоположения
 */
const clickHandler = () => {
  if (!('geolocation' in navigator)) addError(trs('request.not_support_geoposition'))

  navigator.geolocation.getCurrentPosition(
    (position) => {
      center.value = [position.coords.longitude, position.coords.latitude]
      zoom.value = 17
    },
    () => {
      addError(trs('request.not_geoposition'))
    },
  )
}
</script>

<template>
  <div class="v-map-my-position__wrapper">
    <VTooltip location="left" :open-delay="500" :text="$t('itf.map_my_position')">
      <template #activator="{ props }">
        <VBtn class="v-map-my-position__btn" v-bind="props" @click="clickHandler">
          <VIcons type="my_location" />
        </VBtn>
      </template>
    </VTooltip>
  </div>
</template>
